var AttendeeCaptureDoneModal = (function($, window, document, Attendee) {

    var controls = {};
    var regData;

    var getFormattedDateOfBirth = function(data) {
        var day = data.getField('dobDay') || '';
        var year = data.getField('dobYear') || '';

        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var month = parseInt(data.getField('dobMonth'), 10) - 1;

        // Return a concatenated string if the month number is parsed correctly
        // and is a position in the Month array
        if (month >= 0 && month < monthNames.length) {
            return day + ' ' + monthNames[month] + ', ' + year;
        }

        return '';
    };

    var populateModelFields = function(data) {
        controls.firstNameField.text(data.getField('firstName'));
        controls.lastNameField.text(data.getField('lastName'));
        controls.dobField.text(getFormattedDateOfBirth(data));
        controls.phoneField.text(data.getField('phoneNumber'));
        controls.emailField.text(data.getField('email'));
    };

    var clearFields = function() {
        controls.regFields.each(function() {
            $(this).text('');
        });
    };

    var hideModal = function() {
        $('body').removeClass('modal-open-bootstrap');
        controls.acDoneModal.addClass('hidden');
    };

    var showModal = function() {
        $('body').addClass('modal-open-bootstrap');
        controls.acDoneModal.removeClass('hidden');
    };

    var resetModal = function() {
        hideModal();
        clearFields();
    };

    var bindControls = function() {
        var obj = {};

        obj.acDoneModal = $('#attendee-capture-done-modal');
        obj.closeButton = $('#attendee-capture-done-modal .close-ac');
        obj.firstNameField = $('#ac-done-first-name');
        obj.lastNameField = $('#ac-done-last-name');
        obj.dobField = $('#ac-done-dob');
        obj.phoneField = $('#ac-done-phone');
        obj.emailField = $('#ac-done-email');
        obj.regFields = $('.ac-done-value');

        return obj;
    };

    var setData = function(data) {
        regData = data;
        populateModelFields(regData);
    };

    var bindFuncs = function() {
        controls.closeButton.on('click', function() {
            resetModal();
        });
    };

    var init = function() {
        controls = bindControls();
        bindFuncs();
    };

    return {
        init: init,
        showModal: showModal,
        setData: setData
    };

}(window.jQuery, window, document, Attendee));
